import { head, isNil, map, reverse, sortBy, split } from 'lodash/fp'
import { AccessKey } from '../AccessKey'
import { useGetSolarData, useGetSolarDataLists } from '../DataProvider/bapp'
import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { Loading, useTranslate } from 'react-admin'

export const SolarData: React.FC<{ partner: string; hash: string }> = ({
  partner,
  hash
}) => {
  const [accessKey, setAccessKey] = React.useState<string | null | undefined>(
    localStorage.getItem('accessKey')
  )
  const { isLoading, data } = useGetSolarDataLists(partner, hash, accessKey)
  const { mutate, data: result } = useGetSolarData()
  const translate = useTranslate()
  const title = translate('resources.solarData.title')
  React.useEffect(() => {
    if (isLoading || isNil(data)) return
    document.title = title
  }, [isLoading, data, title])
  React.useEffect(() => {
    if (isNil(result)) return
    const { data, name } = result
    const blob = new Blob([Uint8Array.from(data)], {
      type: 'application/zip'
    })
    const downloadUrl = URL.createObjectURL(blob)
    const download = document.createElement('a')
    download.href = downloadUrl
    download.download = name
    download.click()
    window.URL.revokeObjectURL(downloadUrl)
  }, [result])
  if (isNil(accessKey)) return <AccessKey setAccessKey={setAccessKey} />
  const submit =
    (partner: string, hash: string, name: string, key: string) => () => {
      mutate({ partner, hash, name, key, accessKey })
    }
  if (isLoading || isNil(data)) return <Loading />
  return (
    <Box sx={{ m: '1em' }}>
      <Typography variant="h6">{title}</Typography>
      <ul style={{ listStyle: 'none' }}>
        {map((item: { name: string; key: string }) => {
          const { name, key } = item
          return (
            <li>
              <Button
                sx={{ color: 'black', textDecoration: 'underline' }}
                onClick={submit(partner, hash, name, key)}>
                {head(split('.')(name))}
              </Button>
            </li>
          )
        })(reverse(sortBy<{ name: string; key: string }>('name')(data)))}
      </ul>
    </Box>
  )
}
